import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { OAuthState } from '../models/oauth-state'

@Component({
  standalone: false,
  selector: 'app-oauth-callback',
  template: '<app-spinner></app-spinner>',
  styles: []
})
export class OAuthCallbackComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute) { }

  public ngOnInit(): void {
    const state = OAuthState.load()
    const queryParams = this.route.snapshot.queryParamMap

    if (!state.returnTo || state.state !== queryParams.get('state')) {
      this.router.navigate(['not-found'])
      return
    }

    const personaId = queryParams.get('personaId')
    const url = personaId ? `${state.returnTo}/${personaId}` : state.returnTo

    this.router.navigateByUrl(url)
  }

}
